"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortWalletMapper = exports.sortWalletOptions = void 0;
exports.walletSlice = walletSlice;
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const dateUtils_1 = require("../../utils/dateUtils");
exports.sortWalletOptions = {
    newest: 'desc',
    oldest: 'asc',
    spendLimit: 'desc',
};
exports.sortWalletMapper = {
    desc: 'DESC',
    asc: 'ASC',
    newest: 'CREATION_DATE',
    oldest: 'CREATION_DATE',
    spendLimit: 'AMOUNT',
};
const lexico = new lexico_1.default();
const walletInitialState = {
    wallet: {
        cards: [],
        lastPageHasLoaded: true,
        availableStatusText: lexico.trc('Wallet status message', 'Available'),
        approvalStatusText: lexico.trc('Wallet status message', 'Approved'),
        authPaddingPercentage: 7,
        sortValue: {
            newest: 'desc',
        },
        cardStatusFilter: 'active',
        teamFilter: 'all',
        memberFilter: 'all',
        areFiltersManuallySet: false,
        teamOptions: [{ id: 'all', label: 'All Teams' }],
        memberOptions: [{ id: 'all', label: 'All Members' }],
        settlements: [],
        walletDetails: {},
        pager: {
            currentPage: 0,
            hasNextPage: false,
        },
        previousPath: '/wallet',
    },
};
function walletSlice(set) {
    return {
        ...walletInitialState,
        resetWalletFilters() {
            set((state) => {
                state.wallet.sortValue = walletInitialState.wallet.sortValue;
                state.wallet.cardStatusFilter = walletInitialState.wallet.cardStatusFilter;
                state.wallet.teamFilter = walletInitialState.wallet.teamFilter;
                state.wallet.memberFilter = walletInitialState.wallet.memberFilter;
                state.wallet.pager.currentPage = walletInitialState.wallet.pager.currentPage;
                return state;
            }, false, '[resetWalletFilters]');
        },
        setWalletCards(cards) {
            set((state) => {
                state.wallet.cards = cards;
                return state;
            }, false, '[setWalletCards]');
        },
        setWalletSortValue(sortValue) {
            set((state) => {
                state.wallet.sortValue = sortValue;
                return state;
            }, false, '[setWalletSortValue]');
        },
        setWalletDetails(walletDetails) {
            set((state) => {
                state.wallet.walletDetails = walletDetails;
                return state;
            }, false, '[setWalletDetails]');
        },
        setTeamFilter(teamFilter) {
            set((state) => {
                state.wallet.teamFilter = teamFilter;
                return state;
            }, false, '[setTeamFilter]');
        },
        setMemberFilter(memberFilter) {
            set((state) => {
                state.wallet.memberFilter = memberFilter;
                return state;
            }, false, '[setMemberFilter]');
        },
        setAreFiltersManuallySet(areFiltersManuallySet) {
            set((state) => {
                state.wallet.areFiltersManuallySet = areFiltersManuallySet;
                return state;
            }, false, '[setAreFiltersManuallySet]');
        },
        setCardStatusFilter(cardStatusFilter) {
            set((state) => {
                state.wallet.cardStatusFilter = cardStatusFilter;
                return state;
            }, false, '[setCardStatusFilter]');
        },
        setLastPageHasLoaded(lastPageHasLoaded) {
            set((state) => {
                state.wallet.lastPageHasLoaded = lastPageHasLoaded;
                return state;
            }, false, '[setLastPageHasLoaded]');
        },
        setTeamOptions(teamOptions) {
            set((state) => {
                state.wallet.teamOptions = teamOptions;
                return state;
            }, false, '[setTeamOptions]');
        },
        setMemberOptions(memberOptions) {
            set((state) => {
                state.wallet.memberOptions = memberOptions;
                return state;
            }, false, '[setMemberOptions]');
        },
        setSettlementsData(settlements, sortBy = 'most-recent') {
            set((state) => {
                const sortedSettlements = settlements?.toSorted((a, b) => (0, dateUtils_1.compareSettlementDates)(a, b, sortBy));
                state.wallet.settlements = sortedSettlements;
                return state;
            }, false, '[setSettlementsData]');
        },
        setCurrentWalletPage(currentPage) {
            set((state) => {
                state.wallet.pager.currentPage = currentPage;
                return state;
            }, false, '[setCurrentWalletPage]');
        },
        setHasNextPage(hasNextPage) {
            set((state) => {
                state.wallet.pager.hasNextPage = hasNextPage;
                return state;
            }, false, '[setHasNextPage]');
        },
        setWalletPreviousPath(previousPath) {
            set((state) => {
                state.wallet.previousPath = previousPath;
                return state;
            }, false, '[setWalletPreviousPath]');
        },
    };
}
